module.exports = __webpack_public_path__ + "static/bg_home-f746ef52880fcbbcb01633e21084c3dd.jpg";